import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './font.css';
import './colors.css';
import reportWebVitals from './reportWebVitals';
import App from './App.js';
import { BrowserRouter } from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/senado200anos">
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
